/**
 * 	核销记录
 * 	  	>核销详情
 * 
 *  券投放列表
 * 
 *  券码核销
 * 
 *  TODO： 暂时先新建路由，最后统合到coupon
 */
export default [
  {
    path: '/couponCancel',
    component: () => import('@/views/coupon/Index.vue'),
    meta: { requiresAuth: true, title: '核销记录', icon: '', role: true },
    children:
      [
        {
          path: '',
          component: () => import('@/views/coupon/CouponCancel.vue'),
          meta: { title: '核销记录', role: true },
        },
        {
          path: 'couponList',
          component: () => import('@/views/coupon/CouponCancel.vue'),
          meta: { title: '核销记录', role: true },
        },
        {
          path: 'detail',
          component: () => import('@/views/coupon/CouponDetail.vue'),
          meta: { title: '核销详情', role: true },
        },
      ],
  },
  /* {
    path: '/couponPutin',
    component: () => import('@/views/coupon/CouponPutin.vue'),
    meta: { requiresAuth: true, title: '券投放列表', icon: '', role: true },
  }, */
  {
    path: '/couponVerification',
    component: () => import('@/views/coupon/CouponVerification.vue'),
    meta: { requiresAuth: true, title: '券码核销', icon: '', role: true },
    children:
      [
        {
          path: '',
          component: () => import('@/views/coupon/SearchType.vue'),
          meta: { title: '券码核销', role: true },
        },
        {
          path: 'search',
          component: () => import('@/views/coupon/Search.vue'),
          meta: { title: '券码核销', role: true },
        },
        {
          path: 'searchDetail',
          component: () => import('@/views/coupon/SearchDetail.vue'),
          meta: { title: '券码核销', role: true },
        },
        {
          path: 'success',
          component: () => import('@/views/coupon/SearchSuccess.vue'),
          meta: { title: '券码核销', role: true },
        },
        {
          path: 'searchMember',
          component: () => import(/* webpackChunkName: "Activity" */ '@/views/searchMember/Search.vue'),
          meta: { title: '查询会员码', role: true },
        },
        {
          path: 'memberDetail',
          component: () => import(/* webpackChunkName: "Activity" */ '@/views/searchMember/MemberDetail.vue'),
          meta: { title: '会员详情', role: true },
        },
        {
          path: 'singleCoupon',
          component: () => import(/* webpackChunkName: "Activity" */ '@/views/searchMember/SingleCoupon.vue'),
          meta: { title: '单个优惠券详情', role: true },
        }
      ],
  },
];